import React from "react";
import AssetGrid from "./AssetGrid";

interface LogosTabProps {
  assets: BrandAsset[];
  projectId: string;
  onUpload: (file: File) => Promise<void>;
  onDelete: (assetId: string) => void;
  onUpdate: (assetId: string, updates: FormData) => void;
}

const LogosTab: React.FC<LogosTabProps> = ({ assets, projectId, onUpload, onDelete, onUpdate }) => {
  const logoAssets = assets.filter((a) => a.type === "logo");

  const renderMeta = (asset: BrandAsset) => {
    if (asset.metadata?.is_favicon) {
      return <span className="text-xs bg-purple-600/30 text-purple-300 rounded px-1.5 py-0.5">Favicon</span>;
    }
    return null;
  };

  return (
    <AssetGrid
      assets={logoAssets}
      assetType="logo"
      onUpload={onUpload}
      onDelete={onDelete}
      onUpdate={onUpdate}
      renderMeta={renderMeta}
      emptyMessage="No logos yet. Upload your brand logos or use the auto-crawl feature."
    />
  );
};

export default LogosTab;
